// extracted by mini-css-extract-plugin
module.exports = {"container":"Switch_container__qIl6c","switch":"Switch_switch__MrqNy","label":"Switch_label__3glcj","slider":"Switch_slider__2afPt","round":"Switch_round__1hIhn"};